import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=290dea72&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"
import style0 from "./Classify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports